import { render, staticRenderFns } from "./GeneralData.vue?vue&type=template&id=6748d852"
import script from "./GeneralData.vue?vue&type=script&lang=js"
export * from "./GeneralData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports